import { GetTasksDocument } from 'generated/resources/graphql'

import { useBulkUpdateTasks } from 'modules/tasks/hooks/useBulkUpdateTasks'

interface Props {
  assigneeId: string
  ids: string[]
}

export const useResolveTask = ({ assigneeId, ids }: Props) => {
  const { bulkUpdateTasks, loading } = useBulkUpdateTasks()

  return {
    loading,
    resolve: ({ id, done }: { id: string; done: boolean }) => {
      return bulkUpdateTasks({
        variables: {
          tasks: [{ id, status: done ? 'done' : 'todo' }],
        },
        refetchQueries: [
          {
            query: GetTasksDocument,
            variables: { ids, assigneeId },
          },
        ],
      })
    },
  }
}
